import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { toast } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { Globals } from '../../globals';
import { AuthService } from '../../services/auth.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Utils } from '../../util';

export type Tab = { name: string, index: number, loaded: boolean, onOpen: () => Promise<void> };
export type Db_TimbrePurchase = { id?: string, amount: number, date: string };

@Component({
  selector: 'app-superadmin',
  templateUrl: './superadmin.component.html',
  styleUrls: ['./superadmin.component.css']
})
export class SuperadminComponent implements OnInit, OnDestroy {

  tabs: Tab[] = [
    { name: 'Colecciones de firestore', index: 0, loaded: true, onOpen: async () => {} },
    { name: 'Timbres', index: 1, loaded: false, onOpen: async () => {
      console.log('Entered onOpen');
      this.tabs[1].loaded = false;
      let bills = await this.fsService.colWithIds(Globals.CUSTOMER_BILL_COLLECTION);
      let incomes = await this.fsService.colWithIds(Globals.INCOME_COLLECTION);
      window['bills'] = bills;
      window['incomes'] = incomes;
      for(let bill of bills){
        if(bill.Timbrado_xml) this.timbreDatas[0].value++;
        if(bill.Cancelado_xml) this.timbreDatas[1].value++;
      }
      for(let income of incomes){
        if(income.Timbrado_xml) this.timbreDatas[2].value++;
        if(income.uuidHistory) for(let key of Object.keys(income.uuidHistory)) if(!['undefined', income.uuid].includes(key)) this.timbreDatas[3].value++;
      }
      for(let index of [0, 1, 2, 3]) this.timbreDatas[4].value += this.timbreDatas[index].value;
      this.tabs[1].loaded = true;
      console.log('Finished onOpen');
    } },
  ];
  selectedTab: Tab = this.tabs[0];

  constructor(
    private fsService: FirestoreService,
    private authService: AuthService,
    private router: Router,
  ) {
    if(!this.authService.currentUser || !this.authService.currentUser.superadmin) this.router.navigate(['/']);
  }

  ngOnInit() {
    console.log('entered');
    this.timbrePurchasesSub = this.fsService.colWithIds$(Globals.TIMBRE_PURCHASE_COLLECTION).subscribe(timbrePurchases => {
      console.log(timbrePurchases);
      this.timbrePurchases = timbrePurchases;
    });
  }
  ngOnDestroy(){
    if(this.timbrePurchasesSub) this.timbrePurchasesSub.unsubscribe();
  }

  cols = [
    { selected: false, name: 'Employees', path: Globals.EMPLOYEE_COLLECTION },
    { selected: false, name: 'Reporte Seguridad', path: Globals.SECURITY_REPORT_COLLECTION },
    { selected: false, name: 'Reporte Apundator', path: Globals.NEW_PROMPTER_REPORT_COLLECTION },
    { selected: false, name: 'Reporte supervisor', path: Globals.SUPERVISOR_REPORT_COLLECTION },
    { selected: false, name: 'Reporte transportista', path: Globals.CARRIER_REPORT_COLLECTION },
  ];

  async onExcel(){
    let selectedCols = this.cols.filter(col => col.selected);
    if(!selectedCols.length) return toast('Seleccione mínimo una colección.', 2000);
    console.log(selectedCols);
    for(let col of selectedCols){
      console.log(`Doing col '${col.name}', '${col.path}'.`);
      let docs: any[] = await this.fsService.colWithIds(col.path);
      if(!docs[0]){
        alert(`Colección ${col.name}(${col.path}) no tiene registros.`);
        continue;
      }
      let keys: string[] = [];
      for(let doc of docs){
        let docKeys = Object.keys(doc);
        for(let key of docKeys) if(!keys.includes(key)) keys.push(key);
      }
      let rows: string[][] = [ keys ];
      docs.map((doc, index) => {
          let row: string[] = [];
          for(let key of keys){
            let value: string = '';
            if(doc[key] === null || doc[key] === undefined) doc[key] = '';
            try{
              value = `${typeof doc[key] != 'object' ? doc[key].toString() : JSON.stringify(doc[key])}`;
            }catch(error){
              console.log(`Error stringifying value:`, value, `for doc:`, doc);
              value = `${doc[key]}`
            }
            row.push(value);
          }
          rows.push(row);
      });
      console.log(rows);
      
      if(!confirm(`Download excel for col '${col.name}', '${col.path}'?`)) continue;
      let fileName: string = prompt('Ingrese nombre del archivo:', col.name) || 'download';
      Utils.downloadExcel(rows, fileName);
    }
  }

  async onDelete(){
    let selectedCols = this.cols.filter(col => col.selected);
    if(!selectedCols.length) return toast('Seleccione mínimo una colección.', 2000);
    alert('Esta acción es irreversible, se recomienda descargar el excel antes de borrar.');
    if(!confirm(`Borrar ${selectedCols.length} colecciones?`)) return toast('Se canceló el borrado.', 2000);
    let deleted: number = 0, canceled: number = 0;
    for(let col of selectedCols){
      console.log(`Doing col '${col.name}', '${col.path}'.`);
      let docs: any[] = await this.fsService.colWithIds(col.path);
      if(!confirm(`Borrar ${docs.length} documentos de ${col.name}?`)){
        canceled++;
        continue;
      }
      for(let doc of docs) await this.fsService.deleteFull(`${col.name}/${doc.id}`);
      deleted++;
    }
    alert(`Colecciones borradas: ${deleted}\nCanceladas: ${canceled}`);
  }


  timbreDatas: {label: string, value: number}[] = [
    { label: 'Facturas timbradas', value: 0 },
    { label: 'Facturas canceladas', value: 0 },
    { label: 'Igresos timbrados', value: 0 },
    { label: 'Sustituciones de ingreso', value: 0 },
    { label: 'Total', value: 0 },
  ];

  timbrePurchasesSub: Subscription;
  timbrePurchases: Db_TimbrePurchase[] = [];
  get timbrePurchasesTotal(): number {
    return this.timbrePurchases.reduce((acc, cur) => acc + cur.amount, 0);
  }
  async onAddTimbrePurchase(){
    let timbrePurchase: Db_TimbrePurchase = {
      date: prompt('Fecha:', Utils.today),
      amount: NaN,
    };
    if(timbrePurchase.date == null) return;
    while(isNaN(timbrePurchase.amount)){
      let promptedNumber = prompt('Cantidad:');
      if(promptedNumber == null) return;
      timbrePurchase.amount = +promptedNumber;
    }
    await this.fsService.addPromise(Globals.TIMBRE_PURCHASE_COLLECTION, timbrePurchase);
  }
  async onEditTimbrePurchase(timbrePurchase: Db_TimbrePurchase){
    let newTimbrePurchase: Db_TimbrePurchase = {
      date: prompt(`Fecha:\nAnterior: ${timbrePurchase.date}`, timbrePurchase.date),
      amount: NaN,
    };
    if(newTimbrePurchase.date == null) return;
    while(isNaN(newTimbrePurchase.amount)){
      let promptedNumber = prompt(`Cantidad:\nAnterior: ${timbrePurchase.amount}`, `${timbrePurchase.amount}`);
      if(promptedNumber == null) return;
      newTimbrePurchase.amount = +promptedNumber;
    }
    await this.fsService.update(`${Globals.TIMBRE_PURCHASE_COLLECTION}/${timbrePurchase.id}`, newTimbrePurchase);
  }
  async onDeleteTimbrePurchase(timbrePurchase: Db_TimbrePurchase){
    await this.fsService.deleteFull(`${Globals.TIMBRE_PURCHASE_COLLECTION}/${timbrePurchase.id}`);
  }

}
